export const en = {
  "landingPage": {
    "startSearch": "Search listings",
    "latestListings": "Latest listings",
    "map": {
      "title": "Property map"
    },
    "couldBuyOrCouldSellModal": {
      "sell": {
        "title": "Could sell",
        "description": "Great! Once you provide the address and confirm your interest in selling, we’ll anonymously connect you with buyers. You can optionally add more details and cancel your interest at any time."
      },
      "buy": {
        "title": "Could buy",
        "description": "Great! Once you provide the address and confirm your interest in buying, we’ll anonymously connect you with sellers. You can optionally add more details and cancel your interest at any time."
      },
      "submitError": "An error occurred while submitting. Please try again.",
      "addressMismatch": "The address of the building doesn't match the entered address. Please verify your address or select a different building. Clicking on the edge of the building might sometimes result in the neighboring building address."
    }
  },
  "common": {
    "showMore": "Show more",
    "showLess": "Show less",
    "readMore": "Read more...",
    "findingLocation": "Finding your location...",
    "cancel": "Cancel",
    "optional": "optional"
  },
  "propertyMap": {
    "title": "Property map",
    "exploreHint": "Zoom, Find Property, Explore, Sell, Buy"
  },
  "feed": {
    "title": "Latest",
    "button": {
      "showFeed": "Feed",
      "hideFeed": "Hide"
    },
    "likeBuildingEvent": {
      "text": "User liked this building"
    },
    "offMarketWillingnessEvent": {
      "sell": {
        "text": "Owner willing to sell"
      },
      "buy": {
        "text": "Interested buyer"
      }
    },
    "sellerBuyerOverlapEvent": {
      "text": "Sellers and buyers in the same building!"
    }
  },
  "map": {
    "showMap": "Show property map",
    "showFeed": "Show property feed"
  },
  "navbar": {
    "login": "Log in",
    "loggedIn": "Logged in",
    "messages": "Direct messages",
    "jaakkoInfo": "Jaakko info"
  },
  "searchInput": {
    "placeholder": "Find Property, Buy, Sell, Explore"
  },
  "mainMenu": {
    "whatIsJaakko": "What is Jaakko.com?",
    "contact": "Contact",
    "termsConditions": "Terms & Conditions",
    "privacyPolicy": "Privacy Policy",
    "cookies": "Cookies",
    "language": "Language",
    "feedback": "Send Feedback"
  },
  "timeAgo": {
    "justNow": "Now",
    "minutes": "{{count}} min",
    "hours": "{{count}} h",
    "days": "{{count}} d"
  },
  "couldBuyOrCouldSellModal": {
    "couldSellTitle": "Could sell",
    "couldBuyTitle": "Could buy"
  },
  "building": {
    "controls": {
      "follow": "Follow",
      "share": "Share",
      "like": "Like"
    },
    "generalInfo": {
      "property": "Property",
      "redemptionClause": {
        "title": "Redemption clause",
        "yes": "Yes",
        "no": "No"
      },
      "plotOwnership": {
        "title": "Plot",
        "owned": "Own",
        "rented": "Rented"
      }
    },
    "apartments": {
      "title": "Flats",
      "units": {
        "count": "{{count}} units",
        "countEmpty": "- units"
      },
      "roomCount": "{{count}} room",
      "roomCount_one": "{{count}} room",
      "roomCount_other": "{{count}} rooms",
      "fourPlusRooms": "4+ rooms"
    },
    "offMarket": {
      "title": "Listings",
      "titleContractor": "Interests",
      "emptyPlaceholder": {
        "firstLine": "No interests yet.",
        "secondLine": "Could you consider selling or buying here? Tap the button. ☝️"
      },
      "couldSell": "Could sell",
      "couldBuy": "Could buy",
      "contractorInterest": "Interested",
      "shareTitle": {
        "couldSell": "Owner willing to sell",
        "couldBuy": "Interested buyer"
      },
      "sharedEvent": {
        "sellTitle": "Selling interest",
        "buyTitle": "Buying interest",
        "description": "This listing was shared with you."
      },
      "count_one": "{{count}} user",
      "count_other": "{{count}} users",
      "contractorPrebooking": "{{count}} for pre-booking",
      "infoButton": "What are these",
      "infoModalText": "Could you sell or would you like to buy here? Express your interest with just one click - easier than ever! We connect you with the other party anonymously and with no commitments. Conversations open directly in the Messages section, and your email address is only shared if you choose to send a message or reply to an inquiry. You can remove your interest at any time. <1>Read more...</1>",
      "toast": {
        "couldSellNoBuyers": "Great! When a potential buyer is found, you will receive an email.",
        "couldSellAndBuyers": "Also buyers are interested, you can now discuss directly.",
        "couldBuyNoSellers": "Great! When a potential seller is found, you will receive an email.",
        "couldBuyAndSellers": "Also sellers are interested, you can now discuss directly.",
        "userSellerAndBuyer": "You can not be both a seller and a buyer at the same time.",
        "couldBuyContractor": "Great! You can now discuss directly with the contractor."
      },
      "modal": {
        "sell": {
          "title": "Confirm selling interest",
          "description": "Great! Once you confirm your interest in selling, we’ll anonymously connect you with buyers. You can optionally add more details and cancel your interest at any time."
        },
        "buy": {
          "title": "Confirm buying interest",
          "description": "Great! Once you confirm your interest in buying, we’ll anonymously connect you with sellers. You can optionally add more details and cancel your interest at any time."
        },
        "contractor": {
          "olasIntroKuninkaantammi": "Now available for 'pre-pre-reservation' – stunning row houses in Kuninkaantammi! You won't find these anywhere else – show your interest easily by clicking the Interested button.\n\nThe housing company consists of two-story terraced homes. Sustainable and high-quality solutions have been incorporated into the design of these wooden-framed homes, including centralized geothermal heating, solar panel readiness, parquet flooring, window frames without moldings, and integrated dishwashers. Thanks to the expertly selected color schemes, surface materials, and fixed furniture options, each apartment can be tailored into a unique home that reflects its residents' preferences.\n\n  • A terrace and partially thuja-hedge bordered yard extend your personal living space\n • Large windows bring abundant natural light into the interiors\n • Well-designed and high-quality Puustelli kitchens enhance the cooking experience\n • Durable and aesthetically pleasing choices from the extensive range offered by Laattapiste, curated by our experts\n • Custom-made wooden sauna with glass walls crafted by a carpenter, creating a cozy spa-like atmosphere\n\n  The apartments are located in the Kuninkaantammi residential area, combining pleasant tranquility with proximity to essential services. Nearby schools, daycare centers, and shops facilitate smooth daily routines. Efficient public transport connections further enhance ease of commuting around the capital region. Additionally, Kuninkaantammi offers ample opportunities for various hobbies and relaxation.",
          "olasIntroViertola": "Now available for 'pre-pre-reservation' – stunning row houses in Viertola! You won't find these anywhere else – show your interest easily by clicking the Interested button.\n\nThe housing cooperative comprises single-story and two-story terraced homes. The wooden-structured residences incorporate sustainable and high-quality solutions, such as centralized geothermal heating, readiness for solar panel installation, parquet flooring, frameless windows, and integrated dishwashers. The carefully selected range of colors, surface materials, and fixed furniture by our experts allows each apartment to become a personalized home that reflects its residents.\n\n• A terrace and a yard partially bordered by arborvitae hedges expand the living space outdoors.\n• Large windows bring abundant natural light into the rooms.\n• Well-designed, high-quality Puustelli kitchens make cooking effortless.\n• Timeless and visually appealing tile options selected by our specialists from Laattapiste's extensive range.\n• A handcrafted sauna by a carpenter with glass walls creates a cozy, spa-like atmosphere.\n\nThe terraced homes are located in the Viertola residential area, combining a pleasant, village-like ambiance with a central location. Everyday life is effortless thanks to family-friendly services, numerous natural areas, and excellent transport connections. The neighborhood offers everything from daycare centers and dog parks to sports fields. Nearby shops, restaurants, and cafés make daily routines easier. The homes' comfort is enhanced by the unique, versatile environment, ideal for diverse recreational activities.",
          "buyDescription": "Great! By confirming your choice, we'll connect you with a sales representative from Olas. At this stage, you're not committing to anything, and you can remove your buying interest at any time."
        },
        "edit": {
          "menuTitle": "Edit",
          "title": "Edit property details",
          "buyDescription": "Update the details of your buying interest.",
          "sellDescription": "Update the details of your selling interest."
        },
        "cancel": "Cancel",
        "delete": "Remove",
        "deleteConfirmTitle": "Remove listing",
        "deleteConfirmText": "Are you sure you want to remove this listing?",
        "remove": {
          "menuTitle": "Remove"
        },
        "confirm": "Confirm",
        "update": "Update",
        "detailsOptional": "Apartment Details (Optional)",
        "description": "Description",
        "buyingInterestDescriptionPlaceholder": "Add details about the apartments you're interested in...",
        "sellingInterestDescriptionPlaceholder": "Add details about the apartment you could sell...",
        "additionalDetails": "Additional details (Optional)",
        "size": "Size (m²)",
        "sizePlaceholder": "e.g. 65",
        "sizeClass": "Preferred size (m²)",
        "roomsLabel": "Number of rooms",
        "selectRooms": "Select rooms",
        "rooms": "Room",
        "rooms_one": "Room",
        "rooms_other": "Rooms",
        "floor": "Floor",
        "floorPlaceholder": "e.g. 3",
        "renovation": "Renovation status",
        "selectRenovation": "Select status",
        "recentlyRenovated": "Recently renovated",
        "goodCondition": "Good condition",
        "needsRenovation": "Needs renovation",
        "hasElevator": "Has elevator",
        "hasBalcony": "Has balcony/terrace",
        "address": "Address",
        "addressPlaceholder": "Enter property address",
        "loading": "Loading...",
        "checkingBuilding": "Checking for building...",
        "buildingFound": "Building detected at this address",
        "sellInterestNoBuildingFound": "Building not found, please use the Property Map function to sell.",
        "buyInterestNoBuildingFound": "Building not found, please use the Property Map function to buy.",
        "incompleteAddress": "Select the full address from the dropdown, including the building number and city, e.g., Keskuskatu 1, Helsinki. You can also select the building from the property map.",
        "addPropertyImages": "Add property images (up to 30)",
        "dragImagesHere": "Drag images here or click to browse",
        "propertyImage": "Property image",
        "removeImage": "Remove image",
        "uploadFailed": "Upload failed",
        "imageLimitExceeded": "Maximum {{max}} images allowed",
        "pleaseSelectAddress": "Please select an address",
        "sellInterestRegistered": "Your selling interest has been registered successfully!",
        "buyInterestRegistered": "Your buying interest has been registered successfully!",
        "submitError": "An error occurred while submitting. Please try again.",
        "sizeMustBeGreaterThanZero": "Invalid size.",
        "clickBuildingInstruction": "Click the correct building at your address on the map.",
        "buildingSelected": "Building selected",
        "receivedAddress": "Building address:"
      }
    },
    "housingCompanyHoldings": {
      "title": "Housing company holdings",
      "apartments_one": "Flat",
      "apartments_other": "Flats",
      "commercialSpaces_one": "Commercial space",
      "commercialSpaces_other": "Commercial spaces",
      "units": ""
    },
    "jaakko": {
      "sendFeedback": "Please send feedback to"
    },
    "housingCompanyInfo": {
      "title": "Housing company"
    },
    "map": {
      "title": "Map"
    },
    "comments": {
      "title": "General discussion",
      "emptyState": "<0>Here you can discuss the property publicly.</0><1>Start an anonymous discussion! 🥳</1>",
      "placeholder": "Share your thoughts about this property, add a photo or ask a question.",
      "send": "Send",
      "back": "Back",
      "pickPhoto": "Pick photo",
      "takePhoto": "Take photo",
      "commenterOrderNumberFirst": "First."
    },
    "filesDropBox": {
      "title": "Upload articles of association, financial statement, maintenance needs assessment or other related documents."
    },
    "documentDropzone": {
      "clickToUpload": "<0>Select file</0> <2>or drag and drop</2>",
      "termsAgreement": "By uploading documents, you agree to comply with our <1>terms of service</1>, and acknowledge that you have read and accept Jaakkocom Oy's <3>privacy policy</3>.",
      "buttonText": "Analyze",
      "loading": {
        "title": "Analyzing documents...",
        "text": "This may take a few minutes..."
      }
    },
    "buildingInfoBox": {
      "title": "Housing company"
    },
    "financialsInfoBox": {
      "title": "Financials"
    },
    "renovationsInfoBox": {
      "title": "Renovations"
    },
    "maintenanceNeedsAssessmentPlaceHolderText": "Upload a maintenance needs assessment or PTS plan, to get an analysis",
    "articlesOfAssociationPlaceHolderText": "Upload an articles of association, to get an analysis",
    "financialStatementPlaceHolderText": "Upload a financial statement or budget, to get an analysis",
    "streetView": {
      "title": "Street View"
    }
  },
  "mainMenuPages": {
    "faq": {
      "title": "Frequently asked questions",
      "whatIsJaakko": {
        "title": "What is Jaakko.com?",
        "paragraphs": {
          "first": "Jaakko.com is a new service that connects buyers and sellers to each other easier than ever, without obligations. If you don't find an interesting property on the current services or consider selling without the complicated and time-consuming process, Jaakko.com offers a simple and efficient way for a new kind of property interaction",
          "second": "Users of Jaakko.com can also discuss, share information and photos, and ask questions about any building. Through discussions, you can learn more about different properties and get valuable insights from other users.",
        }
      },
      "sellingAndBuying": {
        "title": "Selling and buying through Jaakko.com",
        "howItWorks": {
          "title": "How it works",
          "bulletPoints": {
            "express": "Select a home from the map and express your interest in buying or selling with just one click. Other users will only see that someone from the building might be open to a conversation – nothing more. If you're open to selling, you can also add details and photos to your interest, giving buyers the best possible view of the home directly in their feed.",
            "connect": "When there's mutual interest, you'll be notified via email, and a direct chat will open within Jaakko.com.",
            "anonymous": "Everything is anonymous at first – your email address will only be shared if you choose to respond to the other party's message or initiate contact yourself.",
            "information": "You can start the conversation by sharing what interests you, such as \"Could sell a 2-room apartment\" or \"Looking for a family apartment in the building\".",
            "removeinterest": "You can remove your interest at any time with one click, and you will no longer receive new contact requests.",
            "removechat": "You can delete any conversation at any time, after which you will no longer receive messages from that party."
          },
        },
        "safety": {
          "title": "Please keep safety and good manners in mind:",
          "bulletPoints": {
            "first": "Jaakko.com is designed for connecting people – the service does not participate in actual transactions or verify the identity of the parties involved.",
            "second": "Always verify the other party's identity before making any decisions or payments. This can be done by meeting in person or requesting official documents.",
            "third": "If needed, consult experts such as real estate agents or lawyers to ensure a safe transaction.",
            "fourth": "Messages must not contain offensive, illegal, harassing, or false statements, nor any content that violates laws or good practices.",
            "fifth": "Jaakko.com reserves the right to remove conversations and users who violate the service rules or good manners.",
            "sixth": "By following these guidelines, you help ensure that using the service is safe and enjoyable for everyone."
          }
        },
      },
      "benefits": {
        "title": "What benefits does a Jaakko.com account offer?",
        "paragraphs": {
          "first": "You can browse buildings without a Jaakko.com account, but with a Jaakko.com account you get additional features:",
          "second": "Creating a Jaakko.com account is free and takes only a minute!"
        },
        "bulletPoints": {
          "first": "Express your interest in selling or buying in any building.",
          "second": "Participate in discussions and share experiences.",
          "third": "Follow interesting properties and receive notifications of new information.",
          "fourth": "Share interesting properties.",
          "fifth": "Like interesting properties."
        }
      },
      "howToParticipate": {
        "title": "How do I participate in discussions?",
        "paragraph": "Discussing and sharing photos in the service is anonymous, but requires a Jaakko.com account. Discussions should follow good practices, and not mention your own or other people's names or contact information. Also, discussions should not contain offensive, illegal, disruptive, or false content, or any content that violates laws or good practices."
      },
      "documentAnalysis": {
        "title": "Jaakko also features new developments – what does that mean?",
        "paragraphs": {
          "first": "In collaboration with property developers, Jaakko gives buyers access to new developments that are not yet on the market – not even under construction. This is a unique opportunity to reserve and influence a project before official pre-marketing begins. These properties can't be found anywhere else.",
          "second": "You can express your interest with a single click of the Interested button – clicking the button doesn't commit you to anything. After that, you can chat directly with the developer, ask questions, give input, and reserve early."
        }
      },
      "typesOfRealEstate": {
        "title": "What types of properties does Jaakko cover?",
        "paragraph": "The map-based interface allows for exploring buildings, discussions, and the expression of interest in buying and selling anywhere in the world. If a property doesn't have a precise address (such as island cottages, etc.), it may still be partially missing from the service."
      },
      "payments": {
        "title": "Payments",
        "paragraph": "The basic functions of the service are free of charge, but in the future charges may be made for additional services. The free use of the service does not obligate to future payments."
      },
      "feedback": {
        "title": "How can I give feedback?",
        "paragraph": "All feedback is welcome. You can send feedback to support@jaakko.com. We are constantly developing the service and value your feedback."
      }
    },
    "contactUs": {
      "title": "Contact us",
      "customerSupport": "Customer support:",
      "businessId": "Business ID:",
      "country": "Finland"
    }
  },
  "signupLoginModal": {
    "loginOrSignup": "Login or sign up",
    "continueWithGoogle": "Continue with Google",
    "continueWithFacebook": "Continue with Facebook",
    "orContinueWithEmail": "or continue with email",
    "loginOrSignupButton": "Continue",
    "login": "Login",
    "passwordPlaceholder": "Password",
    "loginButton": "Continue",
    "logout": "Logout",
    "logoutButton": "Continue",
    "emailPlaceholder": "Email",
    "infoBox": {
      "title": "Start using Jaakko",
      "bulletPoints": {
        "first": "Create your Jaakko ID in seconds – just an email needed",
        "second": "Sign in to show buying or selling interest with one click",
        "third": "You need a Jaakko ID to connect with the other party"
      }
    },
    "registerText": {
      "first": "By signing up, you create a Jaakko account and agree to follow our ",
      "second": "terms of service",
      "third": ", and acknowledge that you have read and accept Jaakkocom Oy's ",
      "fourth": "privacy policy."
    },
    "passwordRequirements": {
      "length": "Password must be at least 8 characters long.",
      "uppercase": "Password must contain at least one uppercase letter.",
      "lowercase": "Password must contain at least one lowercase letter.",
      "number": "Password must contain at least one number."
    },
    "checkPassword": "Check password.",
    "unexpectedError": "Oops! Something went wrong.",
    "signup": {
      "title": "Sign up",
      "accountExists": "It looks like you already have an account. Please login.",
      "signupButton": "Continue"
    },
    "emailVerification": {
      "title": "Verify your email address",
      "firstParagraph": "Enter the verification code",
      "secondParagraph": "Enter the verification code, which was sent to {{email}} (if you do not see the email, check your spam folder)",
      "codePlaceholder": "Verification code"
    },
    "forgotPassword": {
      "linkText": "Forgot password?",
      "title": "Reset password",
      "subtitle": "Enter your email address and we'll send you a link to reset your password.",
      "submitMessage": "If an account with that email exists, a password reset link has been sent.",
      "sendLinkButton": "Send Reset Link",
      "backToLogin": "Back to Login"
    },
    "resetPasswordPage": {
      "title": "Set a new password",
      "newPasswordPlaceholder": "New password",
      "confirmPasswordPlaceholder": "Confirm new password",
      "submitButton": "Set New Password",
      "passwordMismatch": "Passwords do not match.",
      "successMessage": "Your password has been reset successfully. You can now log in with your new password.",
      "invalidLink": "Invalid or expired password reset link.",
      "tokenMissing": "Password reset token is missing.",
      "goToLogin": "Go to app"
    }
  },
  "hints": {
    "clickBuilding": "Click any building",
    "zoomInToSeeHouseNumbers": "Zoom in to see house numbers",
    "expressInterest": "Express interest in selling or buying",
  },
  "metaTags": {
    "title": "Jaakko.com | Property Map & Silent Sale",
    "description": "Are you looking to sell your property or buy a new one? Whether you're listing your property for a silent sale or searching for your dream home, it's now easier than ever.",
    "ogTitle": "Jaakko.com | Property Map & Silent Sale",
    "ogDescription": "Are you looking to sell your property or buy a new one? Whether you're listing your property for a silent sale or searching for your dream home, it's now easier than ever.",
    "building": {
      "title": "Property {{address}} - Jaakko.com",
      "description": "Explore {{address}}. Share your interest in selling or buying, or participate in discussions.",
      "ogTitle": "Explore interesting property on Jaakko.com",
      "ogDescription": "Explore {{address}}. Share your interest in selling or buying, or participate in discussions."
    }
  },
  "shareButton": {
    "title": "Explore interesting property on Jaakko.com",
    "text": "Explore {{address}}. Share your interest in selling or buying, or participate in discussions.",
    "linkCopied": "Link copied to clipboard.",
    "linkCopiedError": "Link copy failed. Please copy the link manually."
  },
  "sharePrompt": {
    "sell": {
      "title": "Great! You're willing to sell",
      "description": "Your selling interest has been registered. Share it to find buyers faster!"
    },
    "buy": {
      "title": "Great! You're interested in buying",
      "description": "Your buying interest has been registered. Share it to connect with sellers!"
    },
    "benefit": {
      "findMatchesSeller": "Find potential buyers faster",
      "findMatchesBuyer": "Find potential sellers faster",
      "reachMore": "Reach more interested parties",
      "faster": "Speed up the process"
    },
    "shareButton": "Share Now",
    "skipButton": "Maybe Later"
  },
  "messages": {
    "title": "Direct messages",
    "empty": "When you start a conversation with buyers or sellers, you will find all messages here.",
    "send": "Send",
    "tabs": {
      "inbox": "Inbox",
      "all": "All",
      "support": "Support"
    },
    "firstMessage": "Start of your conversation.",
    "welcomeTitle": "Start of your conversation",
    "welcomeText": "This is the beginning of your conversation with {{ email }}. You can discuss details about the apartment and arrange viewings.",
    "welcomeTextOtherUserHasNotSentMessage": "This is the beginning of your conversation with the other user. You can discuss details about the apartment and arrange viewings.",
    "welcomeTextEmailDisclaimer": "Note that your email address will be shared with the other party if you start a conversation or respond to messages you receive. Likewise, you will receive the other party's email address when you send your first message.",
    "welcomeTips": "Tips for a successful negotiation:",
    "tipPolite": "Be polite and respectful in your communications",
    "tipCaution": "Exercise caution before sharing personal contact information",
    "tipDetails": "You can end the conversation at any time, after which the other person's messages will no longer reach you",
    "writePlaceholder": "Write a message...",
    "chatEndedPlaceholder": "This conversation has ended",
    "chatEndedMessage": "This conversation has been ended. No new messages can be sent.",
    "chatEnded": "Chat ended",
    "endChat": "End chat",
    "endChatConfirmTitle": "End chat",
    "endChatConfirmText": "Are you sure you want to end this conversation? Once ended, neither you nor the other person will be able to send messages in this chat again.",
    "confirm": "End chat",
    "cancel": "Cancel",
    "ending": "Ending",
    "today": "Today",
    "yesterday": "Yesterday",
    "anonymousUser": "Anonymous user"
  },
  "exploreListings": {
    "exploreButton": "Explore Listings",
    "title": "Off-Market Opportunities",
    "titleDesktop": "Discover Off-Market Opportunities",
    "searchPlaceholder": "Search by location",
    "filters": "Filters",
    "listingType": "Listing Type",
    "both": "All",
    "forSale": "Could sell",
    "buyingInterests": "Buying Interests",
    "buyingInterest": "Could buy",
    "propertySize": "Property Size",
    "minSize": "Min",
    "maxSize": "Max",
    "rooms": "Rooms",
    "any": "Any",
    "floor": "Floor",
    "minFloor": "Min",
    "maxFloor": "Max",
    "renovationStatus": "Renovation Status",
    "anyCondition": "Any condition",
    "recentlyRenovated": "Recently renovated",
    "goodCondition": "Good condition",
    "needsRenovation": "Needs renovation",
    "amenities": "Amenities",
    "hasElevator": "Elevator",
    "hasBalcony": "Balcony/Terrace",
    "clearAll": "Clear all",
    "cancel": "Cancel",
    "showResults": "Show results",
    "resultsFound": "results found with filters",
    "noResultsTitle": "No results found",
    "noResultsTitleSecondary": "No results found with filters",
    "noResultsDescription": "Try adjusting your filters or search in a different location.",
    "endOfResults": "You've reached the end of the results",
    "loading": "Loading...",
    "mapLoadError": "Error loading map services",
    "mapLoading": "Loading map services...",
    "today": "Today",
    "yesterday": "Yesterday",
    "daysAgo": "{{days}} days ago",
    "roomsShort": "rooms",
    "floorShort": "Floor",
    "elevator": "Elevator",
    "balcony": "Balcony",
    "contactSeller": "Contact Seller",
    "contactBuyer": "Contact Buyer",
    "viewOnMap": "View on Map",
    "interestedInBuying": "Hi! I'm interested in buying in this building.",
    "interestedInSelling": "Hi! I'm interested in your selling interest.",
    "openBuildingPage": "Open building page",
    "mightAlsoContain": "These {{secondaryResultsCount}} listings might also include what you are looking for:"
  },
  "feedback": {
    "title": "Send Feedback",
    "intro": "We'd love to hear from you! Your feedback helps us improve Jaakko.com.",
    "type": {
      "label": "Feedback Type",
      "general": "General Feedback",
      "bug": "Bug Report",
      "feature": "Feature Request",
      "improvement": "Improvement Suggestion"
    },
    "email": {
      "label": "Your Email",
      "placeholder": "your.email@example.com",
      "help": "We'll use this to respond to your feedback."
    },
    "subject": {
      "label": "Subject",
      "placeholder": "Subject"
    },
    "message": {
      "label": "Your Feedback",
      "placeholder": "Please share your thoughts, suggestions, or report any issues you've encountered..."
    },
    "submit": "Send Feedback",
    "submitting": "Sending...",
    "success": "Thank you for your feedback! We'll get back to you soon via email.",
    "validation": {
      "messageRequired": "Please enter your feedback message.",
      "emailRequired": "Please enter your email address.",
      "emailInvalid": "Please enter a valid email address."
    },
    "error": {
      "submitFailed": "Failed to send feedback. Please try again."
    }
  }
};
